<template>
  <div class="className" />
</template>

<script>
import echarts from 'echarts' // echarts theme
import { debounce } from '@/utils/util'
import geoJson from '@/utils/map.json'
require('echarts/theme/macarons')
var maxNumberArr
var convertData
var geoCoordMap
var data
var name
var sum
var list
export default {
  props: {
    className: {
      type: String,
      default: 'chart',
    },
    width: {
      type: String,
      default: '100%',
    },
    height: {
      type: String,
      default: '100%',
    },
    autoResize: {
      type: Boolean,
      default: true,
    },
    chartData: {
      type: Object,
      default: () => {
        return {}
      },
    },
    province02s: {
      type: Array,
    },
    name: {
      type: String,
      default: null,
    },
    color: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      chart: null,
    }
  },
  watch: {
    chartData: {
      deep: true,
      handler(val) {
        this.setOptions(val)
      },
    },
  },
  mounted() {
    const that = this
    echarts.registerMap('china', geoJson)
    geoCoordMap = {}
    data = []
    console.log(geoJson, 'geoJsongeoJson')

    geoJson.features.forEach((v, index) => {
      console.log(v, '对对对对对对=========vvv')

      name = v.properties.name // 地区名称
      // console.log(name,'对对对对对对=========')
      geoCoordMap[name] = v.properties.center // 地区经纬度
      sum = 0
      console.log()
      // let leg = that.province02s.length - 1
      // console.log(that.province02s, '对对对对对对=========rrrr')
      // if (index <= leg) {
      //   console.log(leg, 'leglegleg')
      //   console.log(index, 'indexindexindex')
      //   list = [
      //     { name: '经销商 ', value: that.province02s[index].dealerCount },
      //     { name: '验收员 ', value: that.province02s[index].examinerCount },
      //     { name: '水工 ', value: that.province02s[index].waterCount },
      //   ]
      //   list.forEach((item, index) => {
      //     sum += Number(item.value)
      //   })
      // } else {
      //   list = []
      // }
      // if (that.province02s.provinceCode.indexOf(name) !== -1) {
      //   list = [
      //     { name: '经销商 ', value: that.province02s[index].dealerCount },
      //     { name: '验收员 ', value: that.province02s[index].examinerCount },
      //     { name: '水工 ', value: that.province02s[index].waterCount },
      //   ]
      // }
      // if (name == '北京' || name == '重庆' || name == '天津' || name == '上海') {
      //   name = name + '市'
      // } else {
      //   name = name + '省'
      // }
      // v.list = []
      console.log(name, '的点点滴滴------')
      that.province02s.forEach((item, indexs) => {
        if (item.provinceCode == name) {
          console.log(item, 'itemitemitem')
          v.list = [
            { name: '订单', value: item.orderCount },
            { name: '经销商 ', value: item.dealerCount },
            { name: '验收员 ', value: item.examinerCount },
            { name: '水工 ', value: item.waterCount },
          ]
        }
      })
      data.push({
        name: name,
        value: sum,
        data: v.list,
      })
      // console.log(data, 'datadatadata')
    })
    convertData = function (geoCoordMap, data) {
      console.log(data, 'datadatadatauuu')
      var res = []
      for (var i = 0; i < data.length; i++) {
        var geoCoord = geoCoordMap[data[i].name]
        console.log()

        if (geoCoord && data[i].data && data[i].data.length) {
          res.push({
            name: data[i].name,
            value: geoCoord.concat(data[i].value),
          })
        }
      }
      return res
    }
    maxNumberArr = function (data, field) {
      field = field ? field : 'value'
      console.log(field, 'fieldfield00')
      var max = 0
      for (var a = 0; a < data.length; a++) {
        if (Number(data[a][field]) > max) {
          max = Number(data[a][field])
        }
      }
      console.log(max, 'maxmax===')
      return max
    }
    this.initChart()
    if (this.autoResize) {
      this.__resizeHandler = debounce(() => {
        if (this.chart) {
          this.chart.resize()
        }
      }, 100)
      window.addEventListener('resize', this.__resizeHandler)
      setTimeout(() => {
        if (this.chart) {
          this.chart.resize()
        }
      }, 600)
    }
  },
  beforeDestroy() {
    if (!this.chart) {
      return
    }
    if (this.autoResize) {
      window.removeEventListener('resize', this.__resizeHandler)
    }
    this.chart.dispose()
    this.chart = null
  },
  methods: {
    setOptions({ x, y } = {}) {
      this.chart.setOption({
        tooltip: {
          trigger: 'item',
          formatter: function (params) {
            if (!params.name || params.name == '') {
              return
            }
            var toolTiphtml = params.name + ':<br>'
            data.forEach((item, index) => {
              if (item.name == params.name) {
                item.data.forEach((item, index) => {
                  toolTiphtml += item.name + ': ' + item.value + ' 个<br>'
                })
              }
            })
            return toolTiphtml
          },
        },
        legend: {
          orient: 'vertical',
          y: 'bottom',
          x: 'right',
          data: ['credit_pm2.5'],
          textStyle: {
            color: '#fff',
          },
        },
        visualMap: {
          show: false,
          min: 0,
          max: maxNumberArr(data),
          left: 'left',
          top: 'bottom',
          text: ['高', '低'],
          calculable: true,
          seriesIndex: [1],
          inRange: {
            color: ['#00568f', '#052d4f'],
          },
        },
        // /*工具按钮组*/
        // toolbox: {
        //   show: true,
        //   orient: 'vertical',
        //   left: 'right',
        //   top: 'center',
        //   feature: {
        //     dataView: {
        //       readOnly: false,
        //     },
        //     restore: {},
        //     saveAsImage: {},
        //   },
        // },
        geo: {
          show: true,
          map: 'china',
          label: {
            normal: {
              show: false,
            },
            emphasis: {
              show: false,
            },
          },
          grid: {
            left: '40px', // 去掉左边距
            right: '0%', // 去掉右边距
            top: '10px', // 根据需要设置顶部边距
            bottom: '20px', // 根据需要设置底部边距
          },
          roam: false,
          itemStyle: {
            normal: {
              areaColor: '#031525',
              borderColor: '#076ba1',
            },
            emphasis: {
              areaColor: '#2B91B7',
            },
          },
        },
        series: [
          {
            name: '散点',
            type: 'scatter',
            coordinateSystem: 'geo',
            symbolSize: function (val) {
              // return val[2] / 10
              return 8
            },
            label: {
              normal: {
                formatter: '{b}',
                position: 'right',
                show: false,
              },
              emphasis: {
                show: false,
              },
            },
            itemStyle: {
              normal: {
                color: 'rgba(255,255,0,0.8)',
              },
            },
            data: convertData(geoCoordMap, data),
          },
          {
            name: '图层',
            type: 'map',
            map: 'china',
            geoIndex: 0,
            aspectScale: 0.75, // 长宽比
            showLegendSymbol: false, // 存在legend时显示
            label: {
              normal: {
                show: true,
              },
              emphasis: {
                show: false,
                textStyle: {
                  color: '#fff',
                },
              },
            },
            roam: true,
            itemStyle: {
              normal: {
                areaColor: '#031525',
                borderColor: '#3B5077',
              },
              emphasis: {
                areaColor: '#2B91B7',
              },
            },
            animation: true,
            data: data,
          },
          {
            name: 'Top 5',
            type: 'effectScatter',
            // type: 'scatter',
            coordinateSystem: 'geo',
            symbolSize: function (val) {
              return val[2] / 15
              // return 8
            },
            showEffectOn: 'render',
            rippleEffect: {
              brushType: 'stroke',
            },
            hoverAnimation: true,
            label: {
              normal: {
                formatter: '{b}',
                position: 'right',
                show: false,
              },
            },
            itemStyle: {
              normal: {
                color: 'rgba(255,255,0,0.8)',
                shadowBlur: 10,
                shadowColor: '#05C3F9',
              },
            },
            zlevel: 1,
            data: convertData(
              geoCoordMap,
              data
                .sort(function (a, b) {
                  return b.value - a.value
                })
                .slice(0, 5)
            ),
          },
        ],
      })
    },
    initChart() {
      this.chart = echarts.init(this.$el, 'macarons')
      this.setOptions(this.chartData)
    },
  },
}
</script>
<style  scoped>
.className {
  width: 100%;
  height: 470px;
}
</style>
